"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateQuantitiesOverlap = exports.validateQuantity = void 0;
/**
 * Validates the quantity of an object.
 *
 * @param object - The object to validate.
 * @returns A boolean indicating whether the quantity is valid.
 */
function validateQuantity(object) {
    if (object.minQuantity >= object.maxQuantity) {
        return false;
    }
    return true;
}
exports.validateQuantity = validateQuantity;
/**
 * Validates if the quantities of objects overlap.
 *
 * @param objects - An array of objects that have quantities.
 * @param exitOnFirst - A boolean indicating whether to exit on the first error.
 * @returns A boolean indicating if the quantities overlap or not.
 */
function validateQuantitiesOverlap(objects, exitOnFirst = false) {
    const errors = [];
    for (const [index, object] of objects.entries()) {
        const previousObject = objects[index - 1];
        if (!previousObject) {
            continue;
        }
        if (object.minQuantity <= previousObject.maxQuantity) {
            errors.push(object);
            if (exitOnFirst) {
                return errors;
            }
        }
    }
    return errors;
}
exports.validateQuantitiesOverlap = validateQuantitiesOverlap;
//# sourceMappingURL=quantity.validations.js.map